// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import InvestingButtonTemplate from '../../TradingPlatformTemplates/InvestingButtonTemplate.html';
import { TerceraButton } from '@front/controls/elements/TerceraButton';
import { ControlsTypes } from '@front/controls/UtilsClasses/FactoryConstants';
export class InvestingButton extends TerceraButton {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.InvestingButton;
    }
}
TerceraButton.extendWith(InvestingButton, {
    template: InvestingButtonTemplate,
    data: function () {
        return {
            text: '',
            investingButtonStyle: '',
            enabled: true
        };
    }
});
